import type { TAtpCourseData, TAtpOptionalCourseData } from '@/_models';

import { isGenEdCourse } from '../courses-helper';

export function weeksSum(courses: (TAtpCourseData | TAtpOptionalCourseData)[]): number {
  let totalCollegeWeeks = 0;
  let totalAtpWeeks = 0;

  courses.forEach((course) => {
    if (isGenEdCourse(course.product_type)) {
      totalCollegeWeeks += parseFloat(`${course?.max_time_limit}`); // college weeks
      totalAtpWeeks += course?.course_length ?? 0; // atp weeks
    }
  });

  const weeksSaving = Math.floor(totalCollegeWeeks - totalAtpWeeks);
  return weeksSaving < 0 ? 0 : weeksSaving;
}
